import React from 'react';
import { Money, MoneyView } from '../../MoneyView';
import { useExchangeRate } from '../../../hooks/useExchangeRate';
import { Tooltip, Box } from '@utex/ui-kit';
import { useTranslation } from 'react-i18next';
import { WarningSymbol } from '../WarningSymbol';
import { css } from '@emotion/react';
import { Pair } from '../../../hooks/useExchangeRate';

const oneDollar: Money = {
  value: 1,
  currency: 'USD',
};

interface Props {
  pair: Pair;
}

export const Value: React.FC<Props> = ({ pair }) => {
  const { t } = useTranslation('conversion');
  const { rate, loading, error } = useExchangeRate(pair);

  if (loading) {
    return <>...</>;
  }

  if (error || !rate) {
    return (
      <Tooltip
        on="click"
        position="bottom-end"
        offsetSkidding={22}
        width={265}
        padding={{ tablesktop: [10, 4], phonablet: [15, 20] }}
        css={css`
          z-index: 1010;
        `}
        trigger={
          <span>
            <WarningSymbol />
          </span>
        }
      >
        <Box textAlign="center">{t('Failed to load rate Refresh page please')}</Box>
      </Tooltip>
    );
  }

  const rubRate: Money =
    rate.currency === 'RUB'
      ? rate
      : {
          value: 1 / rate.value,
          currency: 'RUB',
        };

  return (
    <>
      <MoneyView>{oneDollar}</MoneyView> = <MoneyView rule="2">{rubRate}</MoneyView>
    </>
  );
};
